const getEnvironment = () => {
  const winLocation = location.hostname;
  let env = "";
  switch (true) {
    case winLocation.includes("localhost") ||
      winLocation.includes("nwas-sit.jpmchase.net"):
      env = "sit";
      break;
    case winLocation.includes("uat"):
      env = "uat";
      break;
    case winLocation.includes("nwas-ent"):
      env = "prod";
      break;
    default:
      env = "sit";
  }
  return env;
};
export default getEnvironment;
